import type { StringKey } from '../i18n/strings';

export type MarketingNavItem = {
  labelKey: StringKey;
  href: string;
  external?: boolean;
};

export const marketingNav: MarketingNavItem[] = [
  { labelKey: 'marketingNavApp', href: '/landing#app' },
  { labelKey: 'marketingNavVisi', href: '/landing#visi' },
  { labelKey: 'marketingNavMe', href: '/landing#me' },
  { labelKey: 'marketingNavPricing', href: '/landing#preisplan' },
  { labelKey: 'marketingNavWaitlist', href: '/waiting-list' },
  { labelKey: 'marketingNavSupport', href: '/support' },
];

export const marketingLegalLinks = [
  { label: 'Nutzungsbedingungen', href: '/nutzungsbedingungen' },
  { label: 'Datenschutzerklärung', href: '/datenschutz' },
  { label: 'Cookie-Richtlinie', href: '/cookie-richtlinie' },
  { label: 'Impressum', href: '/impressum' },
] as const;

export const MARKETING_RESERVED_SLUGS = [
  'landing',
  'waiting-list',
  'support',
  'faq',
  'impressum',
  'datenschutz',
  'nutzungsbedingungen',
  'cookie-richtlinie',
] as const;
